import React from 'react'
import { Accordion, Col, Container, Row } from 'react-bootstrap'
import { Router } from '../../Structure/Handlers/Router'
import AddEmployeeAccount from './AddEmployeeAccount'
import EmployeesList from './EmployeesList'
import EmpLists from './EmpLists'
import MarketersList from './MarketersList'
import AddNewMarketer from './AddNewMarketer'
import ClientsList from './ClientsList'
import { Globals } from '../../Structure/Globals/GlobalObs'

const HRPage = () => {
  return (
    <Container>
      {
        Globals.auth.User?.permissions.some(a=>a.id=='19')?(
          <Row className='py-3'>
            <div>
              <button className='button-I btn-cl-I px-5 py-2' onClick={()=>Router.OpenNormalPage(<AddEmployeeAccount/>)}>اضافة موظف جديد</button>
            </div>
            <EmpLists/>
          </Row>):
        (null)
      }
      {
        Globals.auth.User?.permissions.some(a=>a.id=='20')?(      
        <Row className='py-3'>
          <MarketersList/>
        </Row>):
        (null)
      }
      {
        Globals.auth.User?.permissions.some(a=>(a.id=='1' || a.id=='8'))?(      
        <Row className='py-3'>
          <ClientsList/>
        </Row>):
        (null)
      }
    </Container>
  )
}

export default HRPage
